import { CircularProgress } from '@mui/material';
import React from 'react';

const Loader = () => {
  return (
    <div className='h-[510px] flex items-center justify-center flex-col'>
      <CircularProgress
        size={100}
        thickness={5.5}
        sx={{
          color: '#ffb800',
        }}
      />
      <div className='text-[#101828] font-semibold text-xl leading-6 mt-2'>
        Saving Changes
      </div>
    </div>
  );
};

export default Loader;
